export default __webpack_public_path__ + "static/media/iconz.e5010930.jpg";